var React = require('react');

function HierarchySmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 6.5h3.5V8h1V6.5H10V8h1V6a.5.5 0 00-.5-.5h-4V4h-1v1.5h-4A.5.5 0 001 6v2h1V6.5zM6 3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM1.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM6 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM10.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"}));
}

HierarchySmall.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","className":"css-1s665wz"};

module.exports = HierarchySmall;

HierarchySmall.default = HierarchySmall;
